import { HttpClient } from '../HttpClient';
/**
 * * Get List of Employees per Company
 */
export const GetEmployeeList = async ({ Id }) => {
  try {
    const { data } = await HttpClient.get(`/api/employees/searchCriteria`, {
      params: {
        Id,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
